// ── Light bookings loader ──────────────────────────────────────────────
// maviinci_bookings me MUSTAQBIL app base64 photos embed karta hai
// (front_photo, side_photo, advance_receipt, balance_receipt,
// delivery_photo, delivery_log) — poora collection ~164MB hai jisme
// kaam ka data sirf ~3MB. SDK me field-mask nahi hota, isliye list ke
// liye Firestore REST runQuery + select (projection) use karte hain —
// slow network par bhi Campus Orders / Packing seconds me khul jaye.
//
// NOTE: select INCLUDE-list hai. Agar admin panel me booking ka koi
// NAYA field use karo to use STATIC_FIELDS / ITEM_* me add karna hoga,
// warna list me wo field undefined aayega. Photos wale full doc ke
// liye fetchBookingFull(id) hai (detail modal isi se photos laata hai).

import { auth, db } from "../firebase";

const PROJECT_ID = "bluepearl-e9750";
const REST_BASE = `https://firestore.googleapis.com/v1/projects/${PROJECT_ID}/databases/(default)/documents`;

// Admin panel me use hone wale booking fields (photos/receipts chhodkar)
const STATIC_FIELDS = [
    "invoice_no", "customer_name", "customer_mobile", "campus", "status", "gender",
    "total_amount", "advance_amount", "advance_cash", "advance_online", "advance_qr_name",
    "balance_paid", "balance_pay_mode", "remaining_amount", "payment_mode",
    "created_at", "created_by_name", "order_date", "delivery_date",
    "ready_at", "delivered_at", "delivered_by_name", "delivery_log",
    "urgent", "urgent_by_name", "urgent_at",
    "active_items", "delivered_item_ids", "measurements",
    "height_ft", "height_cm", "age_years", "weight_kg", "otp",
];
const ITEM_TYPES = ["coat", "pant", "shirt", "tie", "vest_coat"];
const ITEM_SUFFIXES = ["fabric", "shade", "color", "detail", "price", "ref_image"];
const ITEM_FIELDS = [];
ITEM_TYPES.forEach((t) => {
    for (let i = 1; i <= 3; i++) {
        ITEM_SUFFIXES.forEach((s) => ITEM_FIELDS.push(`${t}_${i}_${s}`));
    }
});
const SELECT_FIELDS = [...STATIC_FIELDS, ...ITEM_FIELDS].map((f) => ({ fieldPath: f }));

// Firestore REST value -> plain JS
const decodeValue = (v) => {
    if (v == null) return null;
    if ("stringValue" in v) return v.stringValue;
    if ("integerValue" in v) return Number(v.integerValue);
    if ("doubleValue" in v) return v.doubleValue;
    if ("booleanValue" in v) return v.booleanValue;
    if ("nullValue" in v) return null;
    if ("timestampValue" in v) return v.timestampValue; // ISO string — new Date() / slice(0,10) dono chalte hain
    if ("arrayValue" in v) return (v.arrayValue.values || []).map(decodeValue);
    if ("mapValue" in v) {
        return Object.fromEntries(
            Object.entries(v.mapValue.fields || {}).map(([k, x]) => [k, decodeValue(x)])
        );
    }
    return null;
};

const decodeDoc = (d) => {
    const obj = Object.fromEntries(
        Object.entries(d.fields || {}).map(([k, v]) => [k, decodeValue(v)])
    );
    obj.id = d.name.split("/").pop();
    return obj;
};

/** Saari bookings, sirf light fields (~3MB, photos ~161MB skip). */
export async function fetchBookingsLight() {
    const user = auth.currentUser;
    const headers = { "Content-Type": "application/json" };
    if (user) headers.Authorization = `Bearer ${await user.getIdToken()}`;
    const res = await fetch(`${REST_BASE}:runQuery`, {
        method: "POST",
        headers,
        body: JSON.stringify({
            structuredQuery: {
                from: [{ collectionId: "maviinci_bookings" }],
                select: { fields: SELECT_FIELDS },
            },
        }),
    });
    if (!res.ok) throw new Error(`bookings light HTTP ${res.status}`);
    const rows = await res.json();
    if (!Array.isArray(rows)) throw new Error("bookings light: unexpected response");
    return rows.filter((r) => r.document).map((r) => decodeDoc(r.document));
}

/** Ek booking ka poora doc (photos/receipts samet) — detail modal ke liye. */
export async function fetchBookingFull(bookingId) {
    const snap = await db.collection("maviinci_bookings").doc(bookingId).get();
    if (!snap.exists) return null;
    return { id: snap.id, ...snap.data() };
}
